var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "relative flex-shrink-0 rounded" }, [
    _c(
      "div",
      {
        staticClass: "flex flex-col w-full h-full",
        class: { "pointer-events-none": _vm.readonly }
      },
      [
        _c("div", {
          staticClass: "h-1.5 w-full flex-shrink-0 rounded-t",
          style: {
            backgroundColor:
              _vm.measurement.target && _vm.measurement.target.curriculum_color
          }
        }),
        _vm._v(" "),
        !_vm.isCollapsed
          ? _c(
              "div",
              {
                staticClass:
                  "flex items-center justify-between flex-shrink-0 w-full px-4 h-9 bg-prim-200",
                attrs: { id: "measurememt-header" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "flex items-center justify-center w-6 h-6 transition-all duration-300 rounded cursor-pointer hover:bg-white",
                    class: { "bg-pure-white": _vm.display === "description" },
                    on: {
                      click: function($event) {
                        _vm.display =
                          _vm.display === "description"
                            ? "target"
                            : "description"
                      }
                    }
                  },
                  [
                    _c("BlIcon", {
                      staticClass: "w-6 h-6",
                      attrs: { icon: "article" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.sessionStatus !== "draft"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "relative flex items-center justify-center w-6 h-6 transition-all duration-300 rounded cursor-pointer hover:bg-white",
                        class: { "bg-pure-white": _vm.display === "comment" },
                        on: {
                          click: function($event) {
                            _vm.display =
                              _vm.display === "comment" ? "target" : "comment"
                          }
                        }
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "chat" }
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass:
                            "absolute w-2 h-2 transition-all duration-300 rounded-full right-px top-px bg-light-purple",
                          class: [
                            _vm.measurement.comment
                              ? "opacity-100"
                              : "opacity-0"
                          ]
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _vm.sessionStatus === "draft"
                      ? _c("BlInputButton", {
                          attrs: {
                            type: "plain",
                            icon: "close",
                            title: "Delete",
                            dense: "",
                            loading: _vm.deleteLoading
                          },
                          on: { clicked: _vm.onDelete }
                        })
                      : _c("BlInputToggle", {
                          class: { "opacity-50": !_vm.isDropped },
                          attrs: {
                            checked: !_vm.isDropped,
                            disabled: _vm.sessionStatus !== "ongoing",
                            loading: _vm.dropLoading
                          },
                          on: { changed: _vm.onDrop }
                        })
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.cardLoading
          ? _c(
              "div",
              {
                staticClass:
                  "flex flex-col items-center justify-center h-full bg-pure-white"
              },
              [_c("div", { staticClass: "blum-loader" })]
            )
          : _c(
              "div",
              {
                staticClass:
                  "flex flex-col h-full gap-2 pb-3 overflow-y-auto rounded-b",
                class: {
                  "pt-3": _vm.isCollapsed
                },
                style: {
                  background:
                    _vm.sessionStatus === "draft" &&
                    _vm.measurement.target.probing_enable
                      ? "linear-gradient(180deg, #FFF 75%, #F2F8CF 100%)"
                      : "#FFFFFF"
                },
                attrs: { id: "measurememt-body" }
              },
              [
                !_vm.isCollapsed
                  ? _c(
                      "div",
                      { staticClass: "flex flex-col gap-1 px-4 py-3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "flex items-center gap-x-2",
                            class: [
                              _vm.display === "target" ||
                              _vm.display === "comment"
                                ? ""
                                : "flex-wrap"
                            ]
                          },
                          [
                            _vm.measurement.target
                              ? _c("BlTextSubtitle3", {
                                  staticClass: "text-slate-700",
                                  class: {
                                    "truncate ":
                                      _vm.display === "target" ||
                                      _vm.display === "comment"
                                  },
                                  attrs: {
                                    text:
                                      _vm.measurement.target.curriculum_name,
                                    title:
                                      _vm.measurement.target.curriculum_name
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.measurement.type &&
                            _vm.measurement.type.includes("Probing")
                              ? _c(
                                  "div",
                                  { staticClass: "flex-shrink-0" },
                                  [
                                    _c("BlTextBody3", {
                                      staticClass:
                                        "px-2 rounded-full text-lime-700 bg-lime-200",
                                      attrs: { text: "Probing" }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.measurement.target
                          ? _c("BlTextSubtitle2", {
                              staticClass: "text-slate-900",
                              class: {
                                "truncate ":
                                  _vm.display === "target" ||
                                  _vm.display === "comment"
                              },
                              attrs: {
                                text: _vm.measurement.target.name,
                                title: _vm.measurement.target.name
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.display === "target"
                  ? _c("div", { staticClass: "flex h-full gap-4 px-4" }, [
                      _vm.isDropped
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-col items-center justify-center flex-grow flex-shrink-0 gap-4 pb-3"
                            },
                            [
                              _c("BlIcon", {
                                staticClass: "w-20 h-20",
                                attrs: {
                                  icon: "clipboard-close",
                                  color: "pending-4"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.isCollapsed
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-col items-center w-full gap-2 max-w-72"
                                    },
                                    [
                                      _c("BlTextSubtitle2", {
                                        staticClass: "text-center",
                                        attrs: { text: "Entry not recorded" }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        staticClass: "text-center",
                                        attrs: {
                                          text:
                                            "This entry will not be saved when the Session ends. Toggle back to save this entry recording."
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              key: "measurement-card-" + _vm.cardId,
                              staticClass: "w-full h-full"
                            },
                            [
                              _vm.measurementType.includes("Duration")
                                ? _c("Duration", {
                                    attrs: {
                                      measurement: _vm.measurement,
                                      sessionStatus: _vm.sessionStatus,
                                      isStarted: _vm.durationStarted,
                                      timer: _vm.durationTimerRunning,
                                      updateLoading: _vm.durationLoading,
                                      isCollapsed: _vm.isCollapsed
                                    },
                                    on: {
                                      "toggle-timer": _vm.onToggleDurationTimer
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.measurementType.includes("Frequency")
                                ? _c("Frequency", {
                                    attrs: {
                                      measurement: _vm.measurement,
                                      sessionStatus: _vm.sessionStatus,
                                      isCollapsed: _vm.isCollapsed
                                    },
                                    on: {
                                      "toggle-updated": function($event) {
                                        return _vm.onToggleUpdated($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.measurementType.includes("Pir")
                                ? _c("PartialIntervalRecording", {
                                    attrs: {
                                      measurement: _vm.measurement,
                                      sessionStatus: _vm.sessionStatus,
                                      counter: _vm.count,
                                      isCollapsed: _vm.isCollapsed
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.measurementType.includes("Percentage")
                                ? _c("Percentage", {
                                    attrs: {
                                      measurement: _vm.measurement,
                                      sessionStatus: _vm.sessionStatus,
                                      isCollapsed: _vm.isCollapsed
                                    },
                                    on: {
                                      "toggle-updated": function($event) {
                                        return _vm.onToggleUpdated($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.measurementType.includes("Probing")
                                ? _c("Probing", {
                                    attrs: {
                                      measurement: _vm.measurement,
                                      sessionStatus: _vm.sessionStatus,
                                      isCollapsed: _vm.isCollapsed
                                    },
                                    on: {
                                      "toggle-collapsed": function($event) {
                                        _vm.isCollapsed = $event
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.measurementType.includes("Prompting")
                                ? _c("Prompting", {
                                    attrs: {
                                      measurement: _vm.measurement,
                                      measurementResults:
                                        _vm.measurement.results || {},
                                      target: _vm.target,
                                      sessionStatus: _vm.sessionStatus,
                                      isCollapsed: _vm.isCollapsed
                                    },
                                    on: {
                                      "toggle-updated": function($event) {
                                        return _vm.onToggleUpdated($event)
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.measurementType.includes("Sbt")
                                ? _c("SkillBasedTreatment", {
                                    attrs: {
                                      measurement: _vm.measurement,
                                      measurementResults:
                                        _vm.measurement.results || {},
                                      target: _vm.target,
                                      sessionStatus: _vm.sessionStatus,
                                      isCollapsed: _vm.isCollapsed
                                    },
                                    on: {
                                      "toggle-saved": function($event) {
                                        return _vm.onToggleSaved($event)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _vm.measurement.is_fixed
                        ? _c("div", { staticClass: "w-8 lg:hidden" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-col items-center justify-center flex-shrink-0 w-8 h-full rounded-full bg-slate-400",
                                on: {
                                  click: function($event) {
                                    _vm.isCollapsed = !_vm.isCollapsed
                                  }
                                }
                              },
                              [
                                _c("BlIcon", {
                                  staticClass: "w-5 h-5",
                                  style: _vm.isCollapsed
                                    ? { transform: "rotate(0deg)" }
                                    : { transform: "rotate(180deg)" },
                                  attrs: {
                                    icon: "chevron-up",
                                    color: "slate-8"
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlIcon", {
                                  staticClass: "w-5 h-5 -mt-2",
                                  style: _vm.isCollapsed
                                    ? { transform: "rotate(0deg)" }
                                    : { transform: "rotate(180deg)" },
                                  attrs: {
                                    icon: "chevron-up",
                                    color: "slate-8"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.display === "description"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "relative flex flex-col justify-between h-full px-4 overflow-y-auto"
                      },
                      [
                        _c("div", { staticClass: "flex flex-col gap-3 py-3" }, [
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-0.5 text-wrap" },
                            [
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    _vm.targetTypes[_vm.measurement.target.type]
                                }
                              }),
                              _vm._v(" "),
                              _vm.measurement.target.type === "Target::Duration"
                                ? _c(
                                    "div",
                                    { staticClass: "flex flex-col gap-0.5" },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody2", {
                                            attrs: { text: "Goal time:" }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text: _vm.measurement.target.goal_time
                                                .split(":")
                                                .join(" : ")
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody2", {
                                            attrs: { text: "Success metric:" }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text:
                                                _vm.measurement.target
                                                  .success_metric
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.measurement.target.type ===
                              "Target::Percentage"
                                ? _c(
                                    "div",
                                    { staticClass: "flex flex-col gap-0.5" },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody2", {
                                            attrs: { text: "Goal:" }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text:
                                                _vm.measurement.target.goal +
                                                "%"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody2", {
                                            attrs: { text: "Number of trials:" }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text:
                                                _vm.measurement.target
                                                  .number_of_trial
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: { text: "trial(s)" }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody2", {
                                            attrs: { text: "Success metric:" }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text:
                                                _vm.measurement.target
                                                  .success_metric
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.measurement.target.type === "Target::Pir"
                                ? _c(
                                    "div",
                                    { staticClass: "flex flex-col gap-0.5" },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody2", {
                                            attrs: { text: "Goal:" }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text:
                                                _vm.measurement.target.goal +
                                                "%"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody2", {
                                            attrs: { text: "Interval:" }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text:
                                                _vm.measurement.target.interval
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: { text: "minute(s)" }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody2", {
                                            attrs: { text: "Duration:" }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text:
                                                _vm.measurement.target.duration
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: { text: "minute(s)" }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody2", {
                                            attrs: { text: "Success metric:" }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text:
                                                _vm.measurement.target
                                                  .success_metric
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.measurement.target.type ===
                              "Target::Frequency"
                                ? _c(
                                    "div",
                                    { staticClass: "flex flex-col gap-0.5" },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody2", {
                                            attrs: { text: "Goal:" }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text: _vm.measurement.target.goal
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text: "attempt(s) per session"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody2", {
                                            attrs: { text: "Success metric:" }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text:
                                                _vm.measurement.target
                                                  .success_metric
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.measurement.target.type ===
                              "Target::Prompting"
                                ? _c(
                                    "div",
                                    { staticClass: "flex flex-col gap-0.5" },
                                    [
                                      _vm.measurement.target
                                        .prompting_format === "classic"
                                        ? _c(
                                            "div",
                                            [
                                              _c("BlTextBody2", {
                                                attrs: {
                                                  text:
                                                    "Goal and success metric: Achieve target with"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextBody2", {
                                                attrs: {
                                                  text:
                                                    _vm.measurement.target
                                                      .success_metric
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextBody2", {
                                                attrs: {
                                                  text: "prompt, minimum"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextBody2", {
                                                attrs: {
                                                  text:
                                                    _vm.measurement.target.goal
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextBody2", {
                                                attrs: {
                                                  text: "attempt(s) per session"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.measurement.target
                                        .prompting_format === "custom"
                                        ? _c(
                                            "div",
                                            [
                                              _c("BlTextBody2", {
                                                attrs: { text: "Goal:" }
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextBody2", {
                                                attrs: {
                                                  text:
                                                    _vm.measurement.target
                                                      .goal + "%"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text:
                                                "Prompts used in this session:"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            attrs: {
                                              text: Object.keys(
                                                _vm.measurement.results
                                              )
                                                .map(function(key) {
                                                  var found = _vm.target.prompts.find(
                                                    function(i) {
                                                      return (
                                                        i.id === Number(key)
                                                      )
                                                    }
                                                  )
                                                  return Object.assign(
                                                    {},
                                                    _vm.measurement.results[
                                                      key
                                                    ],
                                                    {
                                                      percentage:
                                                        found.score || 0
                                                    }
                                                  )
                                                })
                                                .sort(function(a, b) {
                                                  return a.position - b.position
                                                })
                                                .map(function(prompt) {
                                                  if (
                                                    _vm.target
                                                      .prompting_format ===
                                                    "custom"
                                                  ) {
                                                    return (
                                                      prompt.name +
                                                      " (" +
                                                      prompt.percentage +
                                                      "%)"
                                                    )
                                                  }
                                                  return prompt.name
                                                })
                                                .join(", ")
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.measurementType.includes("Probing")
                            ? _c(
                                "div",
                                {
                                  staticClass: "flex flex-col gap-0.5 text-wrap"
                                },
                                [
                                  _c("BlTextBody2", {
                                    attrs: { text: "Probing activated" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("BlTextBody2", {
                                        attrs: { text: "Goal: score" }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: {
                                          text:
                                            _vm.measurement.target
                                              .success_metric ===
                                            "equal to or greater than goal"
                                              ? "≥"
                                              : "<"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: {
                                          text:
                                            _vm.measurement.target
                                              .probing_goal + "%"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: { text: "in minimum" }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: {
                                          text:
                                            _vm.measurement.target
                                              .probing_number_of_trial
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: { text: "trial(s)" }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-0.5 text-wrap" },
                            [
                              !_vm.measurement.target.description
                                ? _c("BlTextBody2", {
                                    staticClass: "italic",
                                    attrs: { text: "No description" }
                                  })
                                : _c("BlTextBody2", {
                                    staticClass: "whitespace-pre-line",
                                    attrs: {
                                      text: _vm.measurement.target.description
                                    }
                                  })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.measurement.target.last_phase_line
                            ? _c(
                                "div",
                                { staticClass: "text-wrap" },
                                [
                                  _c("BlTextBody2", {
                                    attrs: {
                                      text:
                                        "Data from this session will be added to the"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass: "font-semibold",
                                    attrs: {
                                      text:
                                        _vm.measurement.target.last_phase_line
                                          .label
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    attrs: { text: "phase." }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.measurement.target.type === "Target::Sbt"
                            ? _c("div", { staticClass: "flex flex-col" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col gap-3 py-3 border-t-2 border-slate-400"
                                  },
                                  _vm._l(_vm.target.target_tasks, function(
                                    taskCode
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: taskCode.id,
                                        staticClass: "flex flex-col gap-1"
                                      },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c("BlTextSubtitle3", {
                                              attrs: { text: taskCode.code }
                                            }),
                                            _vm._v(" "),
                                            _c("BlTextSubtitle3", {
                                              attrs: { text: "-" }
                                            }),
                                            _vm._v(" "),
                                            _c("BlTextSubtitle3", {
                                              attrs: { text: taskCode.title }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          staticClass: "whitespace-pre-line",
                                          attrs: { text: taskCode.description }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex flex-col gap-3 py-3 border-t-2 border-slate-400"
                                  },
                                  _vm._l(
                                    _vm.target.target_problem_behaviors,
                                    function(problemBehavior) {
                                      return _c(
                                        "div",
                                        {
                                          key: problemBehavior.id,
                                          staticClass: "flex flex-col gap-1"
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c("BlTextSubtitle3", {
                                                attrs: {
                                                  text: problemBehavior.code
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextSubtitle3", {
                                                attrs: { text: "-" }
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextSubtitle3", {
                                                attrs: {
                                                  text:
                                                    problemBehavior.code_definition
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("BlTextBody2", {
                                            staticClass: "whitespace-pre-line",
                                            attrs: {
                                              text: problemBehavior.description
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "sticky bottom-0 w-full py-3 bg-pure-white"
                          },
                          [
                            _c("BlInputButton", {
                              staticClass: "w-full",
                              attrs: {
                                type: "outlined",
                                dense: "",
                                label: "Close"
                              },
                              on: {
                                clicked: function($event) {
                                  _vm.display = "target"
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.display === "comment"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-col justify-between h-full gap-3 px-4"
                      },
                      [
                        _vm.sessionStatus === "ongoing"
                          ? _c("BlInputText", {
                              staticClass: "h-full mt-2",
                              attrs: {
                                input: _vm.commentInput,
                                inputClass: "h-full min-h-64"
                              },
                              on: { changed: _vm.inputHandler }
                            })
                          : _vm.sessionStatus === "draft"
                          ? _c("BlInputText", {
                              staticClass: "h-full mt-2",
                              attrs: {
                                input: {
                                  placeholder: "Type your comment here... ",
                                  textarea: true
                                },
                                inputClass: "h-full min-h-64"
                              }
                            })
                          : _c("BlTextBody2", {
                              staticClass: "pt-3 text-wrap",
                              attrs: { text: _vm.measurement.comment || "-" }
                            }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "sticky bottom-0 w-full py-3 bg-pure-white"
                          },
                          [
                            _vm.sessionStatus === "ongoing"
                              ? _c(
                                  "div",
                                  { staticClass: "grid grid-cols-2" },
                                  [
                                    _c("BlInputButton", {
                                      staticClass: "w-full",
                                      attrs: {
                                        type: "plain",
                                        dense: "",
                                        label: "Cancel"
                                      },
                                      on: {
                                        clicked: function($event) {
                                          _vm.display = "target"
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("BlInputButton", {
                                      staticClass: "w-full",
                                      attrs: {
                                        dense: "",
                                        label: "Save",
                                        disabled: _vm.isDisabledSaveComment,
                                        loading: _vm.commentLoading
                                      },
                                      on: { clicked: _vm.onSaveComment }
                                    })
                                  ],
                                  1
                                )
                              : _c("BlInputButton", {
                                  staticClass: "w-full",
                                  attrs: {
                                    type: "outlined",
                                    dense: "",
                                    label: "Close"
                                  },
                                  on: {
                                    clicked: function($event) {
                                      _vm.display = "target"
                                    }
                                  }
                                })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bc9966a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bc9966a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/MeasurementCard.vue
// module id = null
// module chunks = 